// extracted by mini-css-extract-plugin
export var navItemsWrapper = "NavbarDesktop-module--navItemsWrapper--174e4";
export var navbarDesktop = "NavbarDesktop-module--navbarDesktop--b42a6";